export enum UserRole {
  Administrator = 'Administrator',
  SuperAdministrator = 'SuperAdministrator',
}

export enum StorageKeys {
  session_token = 'session-token',
}

export type serverError = { status: number; data: null; message: string };

export type ErrorMessage = { [key: string]: { [errorKey: string]: string } };

export type StringOrNull = string | null;
export type NumberOrNull = number | null;
export type DateOrNull = Date | null;
export type BoolOrNull = boolean | null;

export interface OrderItem {
  field: string;
  order: 'ASC' | 'DESC';
}

export interface SearchItem {
  field: string;
  value: string;
}

export interface IQueryParams {
  order?: OrderItem;
  limit?: number;
  offset?: number;
  search?: SearchItem[];
}

export enum RecommendationType {
  PRE = "pre",
  POST = "post",
}
